import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSites = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m21 14.001-2-1.22V20h1a1 1 0 0 0 1-1v-5zm-8 4a1 1 0 0 0-.901-.996L12 17a1 1 0 0 0-1 1v2h2v-2zm0-9A1 1 0 1 0 11 9a1 1 0 0 0 2 0zm10 10a3 3 0 0 1-3 3H4a3 3 0 0 1-2.996-2.852L1 19v-4.999a2 2 0 0 1 .96-1.708L5 10.439v-3.84l-.53.283a1 1 0 0 1-.94-1.764l7.105-3.79.024-.013a3 3 0 0 1 2.682 0l.024.013 7.106 3.79a1 1 0 0 1-.942 1.764L19 6.6v3.838l3.04 1.855a2.001 2.001 0 0 1 .96 1.706V19zm-8 1h2V5.532l-4.556-2.43a1 1 0 0 0-.888 0L7 5.533V20h2v-2a3 3 0 0 1 3-3l.149.004A3 3 0 0 1 15 18v2zM3 19l.005.098A1 1 0 0 0 4 20h1v-7.22L3 14v5.001zM15 9A3 3 0 1 1 9 9a3 3 0 0 1 6 0z",
		fill: "currentColor"
	})
});
export default SvgSites;
